<p>{{result && result.message ? result.message : 'Loading...'}}</p>
